import React from 'react'

export function Warning(props) {
  return (
    <svg width="25px" height="25px" viewBox="0 0 256 256" {...props}><path fill="currentColor" d="M128 20a108 108 0 1 0 108 108A108.1 108.1 0 0 0 128 20Zm0 192a84 84 0 1 1 84-84a84.1 84.1 0 0 1-84 84Zm-12-80V80a12 12 0 0 1 24 0v52a12 12 0 0 1-24 0Zm28 40a16 16 0 1 1-16-16a16 16 0 0 1 16 16Z"></path></svg>
  )
}


export function Dashboard(props) {
  return (
    <svg width="1.03em" height="1em" viewBox="0 0 49 48" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4"><path d="M24.778 7c-11.046 0-20 8.954-20 20c0 5.23 1.713 10.436 5 14h30c3.286-3.564 5-8.77 5-14c0-11.046-8.954-20-20-20Z"></path><circle cx="24.778" cy="30" r="4"></circle><path d="M24.778 20v6m0-14v2m-15 14h2m2-10l1.414 1.414M37.778 28h2m-5-8.586L36.192 18"></path></g></svg>
  )
}


export function MonitorIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>{/* Icon from Tabler Icons by Paweł Kuna - https://github.com/tabler/tabler-icons/blob/master/LICENSE */}<g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M19.03 17.818A3 3 0 0 0 21 15V7a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v8c0 1.317.85 2.436 2.03 2.84"></path><path d="M10 14a2 2 0 1 0 4 0a2 2 0 0 0-4 0m-2 7a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2"></path></g></svg>
  )
}

export function Folder(props) {
  return (
    <svg width="35px" height="35px" viewBox="0 0 44 39" {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-21.000000, -414.000000)" stroke="#000000" strokeWidth="2.08333333">
                <g transform="translate(23.000000, 416.000000)">
                    <path d="M40,31.8128661 C40,34.0090858 38.209139,35.7894737 36,35.7894737 L4,35.7894737 C1.79086099,35.7894737 0,34.0090858 0,31.8128661 L0,3.97660755 C0,1.78038793 1.79086099,0 4,0 L14,0 L18,5.96491228 L36,5.96491228 C38.209139,5.96491228 40,7.74530021 40,9.94151983 L40,31.8128661 Z" id="Path"></path>
                </g>
            </g>
        </g>
    </svg>
  )
}


export function OnCall(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M19.95 21q-3.225 0-6.287-1.438q-3.063-1.437-5.425-3.8q-2.363-2.362-3.8-5.425Q3 7.275 3 4.05q0-.45.3-.75t.75-.3H8.1q.35 0 .625.225t.325.575l.65 3.5q.05.35-.012.637q-.063.288-.288.513L6.975 10.9q1.05 1.8 2.638 3.375Q11.2 15.85 13.1 17l2.35-2.35q.225-.225.588-.338q.362-.112.712-.062l3.45.7q.35.075.575.337q.225.263.225.613v4.05q0 .45-.3.75t-.75.3ZM6.025 9l1.65-1.65L7.25 5H5.025q.125 1.025.35 2.025q.225 1 .65 1.975ZM19 18.95v-2.2l-2.35-.475l-1.675 1.675q.975.425 1.988.675q1.012.25 2.037.325Zm-4-1.025ZM6.025 9Z"></path></svg>
  )
}


export function Filter(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61z"></path></svg>
  )
}


export function Download(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zm-5-4v-6"></path><path d="M9.5 14.5L12 17l2.5-2.5"></path></g></svg>
  )
}


export function AddUser(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M14 14.252v2.09A6 6 0 0 0 6 22l-2-.001a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6s6 2.685 6 6s-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"></path></svg>
  )
}

export function ClaroVentas(props) {
  return (
    <svg width="27px" height="27px" viewBox="0 0 27 27" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
        <path d="M8,27 C3.581722,27 0,23.418278 0,19 C0,14.581722 3.581722,11 8,11 C12.418278,11 16,14.581722 16,19 C16,23.418278 12.418278,27 8,27 Z M8,25 C11.3137085,25 14,22.3137085 14,19 C14,15.6862915 11.3137085,13 8,13 C4.6862915,13 2,15.6862915 2,19 C2,22.3137085 4.6862915,25 8,25 Z M9,8 L7,8 L7,0 L9,0 L9,8 Z M19,20 L19,18 L27,18 L27,20 L19,20 Z M16.407273,11.2058956 L15.2036429,9.60862458 L21.592727,4.7941044 L22.7963571,6.39137542 L16.407273,11.2058956 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
      </g>
    </svg>
  )
}


export function Debug(props) {
  return (
    <svg width="35px" height="35px" viewBox="0 0 35 35" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
        <path d="M17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 Z M17.5,33 C26.0604136,33 33,26.0604136 33,17.5 C33,8.93958638 26.0604136,2 17.5,2 C8.93958638,2 2,8.93958638 2,17.5 C2,26.0604136 8.93958638,33 17.5,33 Z M28.6321,19.9113183 L24.8992296,19.2775805 C24.8791492,20.2318175 24.6606954,21.171432 24.2577632,22.0366586 L27.7665068,25.5454022 L26.6690584,26.6428507 L23.4308126,23.3968764 C22.1128745,25.0887333 20.0881778,26.0780336 17.9435704,26.0780336 C15.7989631,26.0780336 13.7742663,25.0887333 12.4563282,23.3968764 L9.21808242,26.6428507 L8.12063398,25.5454022 L11.6216491,22.0366586 C11.2213825,21.1708557 11.0055664,20.2312662 10.9879113,19.2775805 L7.24731233,19.9113183 L7,18.3656163 L10.9879113,17.7086929 L10.9879113,14.3236055 L7.12365616,13.2725281 L7.47916763,11.7809256 L11.212038,12.816546 C11.7145903,10.8597132 13.0431308,9.21807721 14.8521663,8.31855305 L14.8521663,6 L16.3978684,6 L16.3978684,7.72345777 C17.4147064,7.48643211 18.4724344,7.48643211 19.4892724,7.72345777 L19.4892724,6 L21.0349745,6 L21.0349745,8.31855305 C22.8383139,9.20788104 24.1685776,10.834072 24.6828313,12.7779034 L28.4157017,11.7809256 L28.8098557,13.2725281 L24.8992296,14.3236055 L24.8992296,17.7086929 L28.8948693,18.3656163 L28.6321,19.9113183 Z M17.1707194,24.4865963 L17.1707194,14.5013612 L12.5336133,14.5013612 L12.5336133,19.1384673 C12.5367623,21.8253474 14.5113957,24.1027579 17.1707194,24.4865963 Z M12.7577401,12.9556592 L23.1294007,12.9556592 C22.4473805,10.6605568 20.337865,9.08674061 17.9435704,9.08674061 C15.5492758,9.08674061 13.4397603,10.6605568 12.7577401,12.9556592 Z M23.3535275,19.1384673 L23.3535275,14.5013612 L18.7164214,14.5013612 L18.7164214,24.4865963 C21.3757451,24.1027579 23.3503785,21.8253474 23.3535275,19.1384673 Z" fill="#979797" fill-rule="nonzero"></path>
      </g>
    </svg>
  )
}

export function Monitor(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="arcs"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
  )
}


export function ArrowRight(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.41z"></path></svg>
  )
}


export function UserChatIconOLD(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 256 256" {...props}><path fill="currentColor" d="M128 20a108 108 0 1 0 108 108A108.12 108.12 0 0 0 128 20ZM79.57 196.57a60 60 0 0 1 96.86 0a83.72 83.72 0 0 1-96.86 0ZM100 120a28 28 0 1 1 28 28a28 28 0 0 1-28-28Zm94 59.94a83.48 83.48 0 0 0-29-23.42a52 52 0 1 0-74 0a83.48 83.48 0 0 0-29 23.42a84 84 0 1 1 131.9 0Z"></path></svg>
  )
}


export function UserChatIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"><circle cx="12" cy="9.1" r="2.5"></circle><circle cx="12" cy="12" r="9"></circle><path d="M17 19.2c-.317-6.187-9.683-6.187-10 0"></path></g></svg>
  )
}


export function AddLinkIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M17 20v-3h-3v-2h3v-3h2v3h3v2h-3v3h-2Zm-6-3H7q-2.075 0-3.538-1.463T2 12q0-2.075 1.463-3.538T7 7h4v2H7q-1.25 0-2.125.875T4 12q0 1.25.875 2.125T7 15h4v2Zm-3-4v-2h8v2H8Zm14-1h-2q0-1.25-.875-2.125T17 9h-4V7h4q2.075 0 3.538 1.463T22 12Z"></path></svg>
  )
}


export function ChatCallIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455ZM13 11h3l-4-4l-4 4h3v4h2v-4Z"></path></svg>
  )
}


export function DeriveIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M6 7c0 .55.45 1 1 1h7.59l-8.88 8.88a.996.996 0 1 0 1.41 1.41L16 9.41V17c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1z"></path></svg>
  )
}


export function MessageIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M3 16c0 1.103.897 2 2 2h3.586L12 21.414L15.414 18H19c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2H5c-1.103 0-2 .897-2 2v12zM5 4h14v12h-4.414L12 18.586L9.414 16H5V4z"></path><path fill="currentColor" d="M11 14h2v-3h3V9h-3V6h-2v3H8v2h3z"></path></svg>
  )
}


export const CheckCircle = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m10.6 13.8l-2.15-2.15q-.275-.275-.7-.275t-.7.275q-.275.275-.275.7t.275.7L9.9 15.9q.3.3.7.3t.7-.3l5.65-5.65q.275-.275.275-.7t-.275-.7q-.275-.275-.7-.275t-.7.275L10.6 13.8ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Zm0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20Zm0-8Z"></path></svg>
  )
}


export const ErrorCircle=(props)=> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m12 13.4l2.9 2.9q.275.275.7.275t.7-.275q.275-.275.275-.7t-.275-.7L13.4 12l2.9-2.9q.275-.275.275-.7t-.275-.7q-.275-.275-.7-.275t-.7.275L12 10.6L9.1 7.7q-.275-.275-.7-.275t-.7.275q-.275.275-.275.7t.275.7l2.9 2.9l-2.9 2.9q-.275.275-.275.7t.275.7q.275.275.7.275t.7-.275l2.9-2.9Zm0 8.6q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Zm0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20Zm0-8Z"></path></svg>
  )
}


export const BotIcon=(props) =>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M21.928 11.607c-.202-.488-.635-.605-.928-.633V8c0-1.103-.897-2-2-2h-6V4.61c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5c-1.103 0-2 .897-2 2v2.997l-.082.006A1 1 0 0 0 1.99 12v2a1 1 0 0 0 1 1H3v5c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5a1 1 0 0 0 1-1v-1.938a1.006 1.006 0 0 0-.072-.455M5 20V8h14l.001 3.996L19 12v2l.001.005l.001 5.995z"></path><ellipse cx="8.5" cy="12" fill="currentColor" rx="1.5" ry="2"></ellipse><ellipse cx="15.5" cy="12" fill="currentColor" rx="1.5" ry="2"></ellipse><path fill="currentColor" d="M8 16h8v2H8z"></path></svg>
  )
}



export const UserIcon=(props)=> {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m.16 14a6.981 6.981 0 0 0-5.147 2.256A7.966 7.966 0 0 0 12 20a7.97 7.97 0 0 0 5.167-1.892A6.979 6.979 0 0 0 12.16 16M12 4a8 8 0 0 0-6.384 12.821A8.975 8.975 0 0 1 12.16 14a8.972 8.972 0 0 1 6.362 2.634A8 8 0 0 0 12 4m0 1a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4"></path></svg>
  )
}


export const ExecIcon=(props)=>{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M12 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6"></path><path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9s-9-1.8-9-9s1.8-9 9-9"></path><path d="M6 20.05V20a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v.05"></path></g></svg>
  )
}


export function DashboardIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 14 14" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><rect width="5" height="7" x="8.5" y="6.5" rx=".5"></rect><rect width="5" height="3.01" x="8.5" y=".5" rx=".5"></rect><rect width="5" height="7" x=".5" y=".5" rx=".5"></rect><rect width="5" height="3.01" x=".5" y="10.49" rx=".5"></rect></g></svg>
  )
}


export function UserRoundedIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M12 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6"></path><path d="M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9s-9-1.8-9-9s1.8-9 9-9"></path><path d="M6 20.05V20a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v.05"></path></g></svg>
  )
}


export function ViewIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 48 48" {...props}><g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="4"><path d="M24 36c11.046 0 20-12 20-12s-8.954-12-20-12S4 24 4 24s8.954 12 20 12Z"></path><path d="M24 29a5 5 0 1 0 0-10a5 5 0 0 0 0 10Z"></path></g></svg>
  )
}


export function RefreshIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M4 20v-2h2.75l-.4-.35q-1.3-1.15-1.825-2.625T4 12.05q0-2.775 1.662-4.938T10 4.25v2.1Q8.2 7 7.1 8.563T6 12.05q0 1.125.425 2.188T7.75 16.2l.25.25V14h2v6zm10-.25v-2.1q1.8-.65 2.9-2.212T18 11.95q0-1.125-.425-2.187T16.25 7.8L16 7.55V10h-2V4h6v2h-2.75l.4.35q1.225 1.225 1.788 2.663T20 11.95q0 2.775-1.662 4.938T14 19.75"></path></svg>
  )
}

export function ArrowIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M16.15 13H5q-.425 0-.712-.288T4 12q0-.425.288-.712T5 11h11.15L13.3 8.15q-.3-.3-.288-.7t.288-.7q.3-.3.713-.312t.712.287L19.3 11.3q.15.15.213.325t.062.375q0 .2-.062.375t-.213.325l-4.575 4.575q-.3.3-.712.288t-.713-.313q-.275-.3-.288-.7t.288-.7z"></path></svg>
  )
}


export function DownloadIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 7v7m0 0l3-3m-3 3l-3-3"></path><path strokeLinecap="round" d="M16 17H8"></path><path d="M2 12c0-4.714 0-7.071 1.464-8.536C4.93 2 7.286 2 12 2c4.714 0 7.071 0 8.535 1.464C22 4.93 22 7.286 22 12c0 4.714 0 7.071-1.465 8.535C19.072 22 16.714 22 12 22s-7.071 0-8.536-1.465C2 19.072 2 16.714 2 12Z"></path></g></svg>
  )
}


export function CalendarIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M1.75 3.75h12.5v10.5H1.75zm9.5-2v1.5m-6.5-1.5v1.5m-2.5 4h11.5"></path></svg>
  )
}

export function DownloadingIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2"><path strokeDasharray="2 4" strokeDashoffset="6" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21"><animate attributeName="stroke-dashoffset" dur="0.6s" repeatCount="indefinite" values="6;0"></animate></path><path strokeDasharray="30" strokeDashoffset="30" d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.1s" dur="0.3s" values="30;0"></animate></path><path strokeDasharray="10" strokeDashoffset="10" d="M12 8v7.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="10;0"></animate></path><path strokeDasharray="6" strokeDashoffset="6" d="M12 15.5l3.5 -3.5M12 15.5l-3.5 -3.5"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.2s" values="6;0"></animate></path></g></svg>
  )
}


export function MinimizeMsgIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 14h6v6m10-10h-6V4m0 6l7-7M3 21l7-7"></path></svg>
  )
}


export function MaximizeMsgIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"></path></svg>
  )
}


export function AssistedIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M4 16q-.425 0-.712-.288T3 15t.288-.712T4 14h6q.425 0 .713.288T11 15t-.288.713T10 16zm0-4q-.425 0-.712-.288T3 11t.288-.712T4 10h10q.425 0 .713.288T15 11t-.288.713T14 12zm0-4q-.425 0-.712-.288T3 7t.288-.712T4 6h10q.425 0 .713.288T15 7t-.288.713T14 8zm12.35 10.575q-.2 0-.375-.062t-.325-.213l-2.15-2.15q-.275-.275-.287-.687t.287-.713q.275-.275.688-.288t.712.263l1.45 1.425l3.525-3.525q.3-.3.713-.287t.712.312q.275.3.288.7t-.288.7l-4.25 4.25q-.15.15-.325.213t-.375.062"></path></svg>
  )
}


export function OutboundIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m8.9 16.5l5.1-5.1v2.25h2V8h-5.65v2h2.225L7.5 15.075zM12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path></svg>
  )
}


export function InboundIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="m11 12.2l-.9-.9q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275l-.9.9V9q0-.425-.288-.712T12 8t-.712.288T11 9zm1 9.8q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"></path></svg>
  )
}


export function InfoIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}><path fill="#BFBFBF" stroke='none' fillRule="evenodd" d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M9 5a1 1 0 1 1-2 0a1 1 0 0 1 2 0M6.75 8a.75.75 0 0 0 0 1.5h.75v1.75a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8.25 8z" clipRule="evenodd" /></svg>
  )
}


export function ShowIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width || "32"} height={props.height || "32"} viewBox="0 0 48 48"><g fill="none" stroke="#888888" stroke-linejoin="round" stroke-width="4"><path d="M24 36c11.046 0 20-12 20-12s-8.954-12-20-12S4 24 4 24s8.954 12 20 12Z" /><path d="M24 29a5 5 0 1 0 0-10a5 5 0 0 0 0 10Z" /></g></svg>
  )
}


export function HideIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width || "32"} height={props.height || "32"} viewBox="0 0 48 48"><path fill="none" stroke="#888888" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M6 16c.635 1.22 1.596 2.35 2.823 3.355C12.26 22.173 17.779 24 24 24s11.739-1.827 15.177-4.645C40.404 18.35 41.365 17.22 42 16m-13.022 8l2.07 7.727m6.306-10.373l5.656 5.656M5 27.01l5.657-5.657m6.271 10.375L18.998 24" /></svg>
  )
}


export function GetAudioIcon({ size, color, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size || "1em"} height={size || "1em"} viewBox="0 0 24 24" {...props}>{/* Icon from Solar by 480 Design - https://creativecommons.org/licenses/by/4.0/ */}<g fill={color || "#888888"} fillRule="evenodd" clipRule="evenodd"><path d="M11.075 7.508c-1.329-.784-2.825.283-2.825 1.705v5.574c0 1.422 1.496 2.489 2.825 1.705l4.72-2.787c1.273-.752 1.273-2.658 0-3.41zM9.75 9.213c0-.198.096-.337.21-.408a.32.32 0 0 1 .352-.005l4.72 2.787a.47.47 0 0 1 .218.413a.47.47 0 0 1-.218.413l-4.72 2.787a.32.32 0 0 1-.353-.005a.47.47 0 0 1-.209-.408z" /><path d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75S22.75 17.937 22.75 12S17.937 1.25 12 1.25M2.75 12a9.25 9.25 0 1 1 18.5 0a9.25 9.25 0 0 1-18.5 0" /></g></svg>
  )
}

export function ExternalCallIcon(props) {
  return (
    <svg
      width="27px"
      height="27px"
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <path
          d="M6.43174333,21.2781722 L4.26967605,23.3579474 C1.86724876,20.8604615 0.5,17.5358782 0.5,14 C0.5,6.54415588 6.54415588,0.5 14,0.5 C19.9806996,0.5 25.197353,4.42354944 26.915125,10.0585014 L24.045499,10.933285 C22.7100017,6.55234088 18.6516854,3.5 14,3.5 C8.20101013,3.5 3.5,8.20101013 3.5,14 C3.5,16.7525297 4.56169325,19.3341284 6.43174333,21.2781722 Z M14.6333333,26.3333425 C14.1,26.3333425 13.5888889,26.2333425 13.1,26.0333425 C12.6111111,25.8333425 12.1777778,25.5444536 11.8,25.1666758 L5,18.3333425 L6.1,17.2000091 C6.41111111,16.888898 6.78888889,16.6777869 7.23333333,16.5666758 C7.67777778,16.4555647 8.12222222,16.4555647 8.56666667,16.5666758 L10.8666667,17.2333425 L10.8666667,6.33334248 C10.8666667,5.9555647 10.9946667,5.63912026 11.2506667,5.38400915 C11.5066667,5.12889804 11.8231111,5.00089804 12.2,5.00000455 C12.5768889,4.99912026 12.8937778,5.12712026 13.1506667,5.38400915 C13.4075556,5.64089804 13.5351111,5.95734248 13.5333333,6.33334248 L13.5333333,20.7666758 L10.2666667,19.8333425 L13.7,23.2666758 C13.8333333,23.4000091 13.9777778,23.5000046 14.1333333,23.5666758 C14.2888889,23.6333425 14.4555556,23.6666758 14.6333333,23.6666758 L20.2,23.6666758 C20.9333333,23.6666758 21.5613333,23.4057869 22.084,22.8840091 C22.6066667,22.3622314 22.8675556,21.7342314 22.8666667,21.0000046 L22.8666667,15.6666758 C22.8666667,15.288898 22.9946667,14.9724536 23.2506667,14.7173425 C23.5066667,14.4622314 23.8231111,14.3342314 24.2,14.3333425 C24.5768889,14.3324536 24.8937778,14.4604536 25.1506667,14.7173425 C25.4075556,14.9742314 25.5351111,15.2906758 25.5333517,15.6666758 L25.5333517,21.0000046 C25.5333517,22.4666758 25.0111111,23.7222314 23.9666667,24.7666758 C22.9222222,25.8111203 21.6666667,26.3333425 20.2,26.3333425 L14.6333333,26.3333425 Z M14.8666667,17.0000091 L14.8666667,11.6666758 C14.8666667,11.288898 14.9946667,10.9724536 15.2506667,10.7173425 C15.5066667,10.4622314 15.8231111,10.3342314 16.2,10.3333379 C16.5768889,10.3324536 16.8937778,10.4604536 17.1506667,10.7173425 C17.4075556,10.9742314 17.5351111,11.2906758 17.5333517,11.6666758 L17.5333517,17.0000091 L14.8666667,17.0000091 Z M18.8666667,17.0000091 L18.8666667,13.0000091 C18.8666667,12.6222314 18.9946667,12.3057869 19.2506667,12.0506758 C19.5066667,11.7955647 19.8231111,11.6675647 20.2,11.6666712 C20.5768889,11.6657869 20.8937778,11.7937869 21.1506667,12.0506758 C21.4075556,12.3075647 21.5351111,12.6240091 21.5333517,13.0000091 L21.5333517,17.0000091 L18.8666667,17.0000091 Z M20.2,23.6666758 L13.7,23.6666758 L20.2,23.6666758 Z"
          id="Combined-Shape"
          fill="#9C9C9C"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}



